import useSWR from 'swr';
import baseFetcher from '../../shared/baseFetcher';

const fetcher = (key) => baseFetcher({
  url: key,
});

const useOffer = (id, options) => (
  useSWR(`/prequals/${id}/offers`, fetcher, { refreshInterval: 3000, ...options }).data
);

export default useOffer;
